import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-route-location',
  templateUrl: './route-location.component.html',
  styleUrls: ['./route-location.component.css']
})
export class RouteLocationComponent implements OnInit {

  constructor(
    private router: Router
  ) {
    this.router.navigate(['locations']);
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/wamp64/www/duetz.repos/angular4/src/app/_components/locations/route-location/route-location.component.ts